<template>
  <div :id="id" class="modal-popup">
    <div class="modal-popup-content">
      <img src="@/assets/images/loading.gif" />
      <p v-html="$t('loadingPopupMessage')"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalPopupLoading",
  props: {
    id: {
      default: "modal_popup_loading",
      type: String,
    },
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
